module.exports = __webpack_public_path__ + "static/media/scoredGoals.bf77aa76.svg";